import { Button, TableCell } from "@mui/material";
import React, { useState } from "react";
import ViewServiceModal from "./view-service-modal";
import {useNavigate} from "react-router-dom";

const DataTableColumn = ({ row, column, value, isHeader, panelUuid,color }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  // Truncate function for specific column
  const truncateText = (text, limit) => {
    return text.length > limit ? `${text.slice(0, limit)}...` : text;
  };

  // Truncate function for specific column
    const truncateUrlText = (text, limit) => {
        // Remove http:// or https:// and any trailing slashes
        let cleanedText = text.replace(/^https?:\/\//i, '').replace(/\/+$/, '');

        // Truncate the cleaned text if it exceeds the limit
        return cleanedText.length > limit
            ? `${cleanedText.slice(0, limit)}...`
            : cleanedText;
    };
    const navigate = useNavigate(); // Initialize navigate function

    const handleCellClick = (uuid) => {
        if (row.search_first){
            window.open(`${window.location.origin}/AdsPanelsDetails/${uuid}`, '_blank', 'noopener,noreferrer');
        }else{
            window.open(`${window.location.origin}/panelsDetails/${uuid}`, '_blank', 'noopener,noreferrer');
        }

    };

  return (
    <TableCell
      key={column.id}
      onClick={(event) => {
          // Prevent triggering onClick for buttons
          if (column.id === "panelUrl") {
              event.stopPropagation(); // Prevent row click event
              handleCellClick(row.panel_uuid); // Call the passed function with row UUID
          }
      }}
      style={{
        border: "1px solid #00000080",
        fontWeight: isHeader ? "bold" : "normal", // Make headers bold if needed
           cursor: column.id == "panelUrl" ? 'pointer' : 'default',
      }}
    >
      {isHeader ? (
        // Render header without truncation
        column.label
      ) : column.id === "id" ? (
        row.search_first ? (
          <>
            <svg
              width="23"
              height="13"
              viewBox="0 0 23 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_367_7828)">
                <rect
                  x="0.4375"
                  y="0.619141"
                  width="22.4392"
                  height="12.021"
                  rx="4.007"
                  fill="#3F78E0"
                />
                <path
                  d="M2.30957 9.61914L4.85802 2.69505H5.9351L3.54052 9.61914H2.30957ZM7.53149 9.61914L5.14652 2.69505H6.28131L8.82014 9.61914H7.53149ZM3.62707 6.89759H7.41609V7.89773H3.62707V6.89759ZM10.4492 9.61914V8.61899H12.2379C12.7637 8.61899 13.2124 8.51321 13.5843 8.30164C13.9561 8.09007 14.2382 7.79515 14.4306 7.41689C14.6293 7.03863 14.7287 6.60588 14.7287 6.11863C14.7287 5.63779 14.6293 5.21465 14.4306 4.84921C14.2382 4.48377 13.9561 4.20168 13.5843 4.00293C13.2188 3.79777 12.7701 3.69519 12.2379 3.69519H10.4684V2.69505H12.2379C12.9945 2.69505 13.6548 2.83609 14.219 3.11819C14.7832 3.40028 15.2191 3.80098 15.5269 4.32029C15.841 4.83318 15.9981 5.43904 15.9981 6.13786C15.9981 6.83668 15.841 7.44895 15.5269 7.97467C15.2127 8.49398 14.7736 8.89788 14.2094 9.18638C13.6516 9.47489 12.9977 9.61914 12.2476 9.61914H10.4492ZM9.68948 9.61914V2.69505H10.9397V9.61914H9.68948ZM18.8536 9.71531C18.174 9.71531 17.6323 9.57426 17.2284 9.29217C16.8245 9.00367 16.6033 8.60617 16.5648 8.09969H17.6707C17.7028 8.34972 17.8214 8.53885 18.0266 8.66708C18.2317 8.7953 18.5074 8.85941 18.8536 8.85941C19.1678 8.85941 19.4018 8.81133 19.5556 8.71516C19.7159 8.61258 19.7961 8.46833 19.7961 8.28241C19.7961 8.14777 19.7512 8.03878 19.6614 7.95543C19.5717 7.86568 19.4018 7.79195 19.1517 7.73425L18.3632 7.55153C17.8246 7.43613 17.4239 7.25661 17.1611 7.01299C16.9046 6.76295 16.7764 6.45201 16.7764 6.08016C16.7764 5.62496 16.9495 5.26914 17.2957 5.01269C17.6483 4.74984 18.1324 4.61841 18.7478 4.61841C19.3569 4.61841 19.8441 4.74984 20.2096 5.01269C20.5814 5.26914 20.7866 5.62496 20.8251 6.08016H19.7191C19.6871 5.88141 19.5845 5.73075 19.4114 5.62817C19.2447 5.52559 19.0139 5.4743 18.719 5.4743C18.4433 5.4743 18.2349 5.51918 18.0939 5.60894C17.9528 5.69228 17.8823 5.8173 17.8823 5.98399C17.8823 6.11222 17.9368 6.22121 18.0458 6.31096C18.1548 6.39431 18.3375 6.46804 18.594 6.53215L19.4402 6.72448C19.9211 6.83348 20.2833 7.02261 20.5269 7.29188C20.777 7.56115 20.902 7.8785 20.902 8.24394C20.902 8.71196 20.7225 9.07419 20.3635 9.33064C20.0044 9.58708 19.5011 9.71531 18.8536 9.71531Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_367_7828">
                  <rect
                    x="0.4375"
                    y="0.619141"
                    width="22.4392"
                    height="12.021"
                    rx="4.007"
                    fill="white"
                  />
                </clipPath>
              </defs>
            </svg>
            {value}
          </>
        ) : (
          value
        )
      ) : column.id === "name" && typeof value === "string" ? (
        // Truncate only 'name' column in body rows
        value
      ) : typeof value === "string" && value === "View" ? (
        <Button onClick={handleOpen}>View</Button>
      ) : column.id==="panelUrl" && row.search_first  ?(
        // Default behavior for other text values (no truncation)
        <span style={{color:'#3f78e0'}}>{truncateUrlText(value, 50)}</span>
      ) : column.id==="panelUrl" ? truncateUrlText(value, 50) : truncateText(value, 50)
      }
      <ViewServiceModal
        open={open}
        setOpen={setOpen}
        data={{ ...row, panelUuid }}
      />
    </TableCell>
  );
};

export default DataTableColumn;
